import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Drawer, IconButton, Slider, TextField, Typography } from "@mui/material"
import React, { SyntheticEvent, useState } from "react";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { FiltersContext } from "./filtersProvider";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneIcon from '@mui/icons-material/Done';
import { IQuestion } from "../types";

interface FilterMenuProps {
    setCursor: (q: IQuestion | null) => void;
}

export const MIN_NUM_MARKS = 1;
export const MAX_NUM_MARKS = 20;
export const MIN_YEAR = 2000;
export const MAX_YEAR = 2025;

export const FilterMenu = (props: FilterMenuProps) => {
    const [open, setOpen] = useState(false);

    const { setFilters } = useContextWithGuard(FiltersContext, "FiltersContext");
    const [expanded, setExpanded] = useState<string | false>(false);
    const [applied, setApplied] = useState<string | false>(false);
    const [numMarks, setNumMarks] = useState<number[]>([MIN_NUM_MARKS, MAX_NUM_MARKS])
    // const [board, setBoard] = useState<string>("")
    const [year, setYear] = useState<number[]>([MIN_YEAR, MAX_YEAR])
    const [difficulty, setDifficulty] = useState<number[]>([0, 100])

    const handleAccordionChange =
        (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const applyClickHandler = (value: string | false) => {
        setApplied(value);
        props.setCursor(null);
        if (value) {
            switch (value) {
                case "num_marks":
                    setFilters([
                        { field: "num_marks", op: ">=", value: numMarks[0] },
                        { field: "num_marks", op: "<=", value: numMarks[1] },
                    ]);
                    break;
                // case "board":
                //     setFilters([{ field: "board", op: "==", value: board.toLowerCase() }]);
                //     break;
                case "year":
                    setFilters([
                        { field: "year", op: ">=", value: year[0] },
                        { field: "year", op: "<=", value: year[1] },
                    ]);
                    break;
                case "difficulty":
                    setFilters([
                        { field: "difficulty", op: ">=", value: difficulty[0] },
                        { field: "difficulty", op: "<=", value: difficulty[1] },
                    ]);
                    break;
            }
        }
        else {
            setFilters([]);
        }
    }

    function updateMarks(newValue: number[]): void {
        setNumMarks(newValue);
        if (applied == "num_marks") {
            props.setCursor(null);
            setFilters([
                { field: "num_marks", op: ">=", value: newValue[0] == MIN_NUM_MARKS ? 0 : newValue[0] }, //MAKE SURE THAT DATABASE SEARCHES ITEMS WITH ZERO MARKS (shown as ONE) 
                { field: "num_marks", op: "<=", value: newValue[1] },
            ]);
        }
    }

    // function updateBoard(value: string): void {
    //     setBoard(value);
    //     if (applied == "board") {
    //         props.setCursor(null);
    //         setFilters([{ field: "board", op: "==", value: board.toLowerCase() }]);
    //     }
    // }

    function updateYear(newValue: number[]): void {
        setYear(newValue);
        if (applied == "year") {
            props.setCursor(null);
            setFilters([
                { field: "year", op: ">=", value: year[0] },
                { field: "year", op: "<=", value: year[1] },
            ]);
        }
    }

    function updateDifficulty(newValue: number[]): void {
        setDifficulty(newValue);
        if (applied == "difficulty") {
            props.setCursor(null);
            setFilters([
                { field: "difficulty", op: ">=", value: difficulty[0] },
                { field: "difficulty", op: "<=", value: difficulty[1] },
            ]);
        }
    }

    return (
        <>
            <IconButton
                size="large"
                edge="start"
                aria-label="settings"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                aria-haspopup="true"
                onClick={() => setOpen(true)}
                title="filter menu"
                color="primary"
            >
                <FilterAltIcon />
            </IconButton>

            <Drawer
                id="menu-appbar"
                open={open}
                onClose={() => setOpen(false)}
            >
                <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography>
                            Number of marks
                        </Typography>
                        <Box flexGrow={1} />
                        {applied == "num_marks" && <DoneIcon />}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Slider
                            value={numMarks}
                            onChange={(e, newValue: number[]) => updateMarks(newValue)}
                            valueLabelDisplay="on"
                            sx={{ width: "150px", marginTop: "10px" }}
                            min={MIN_NUM_MARKS}
                            max={MAX_NUM_MARKS}
                        />
                    </AccordionDetails>
                    <AccordionActions>
                        <Button onClick={() => applyClickHandler(applied == "num_marks" ? false : "num_marks")}>
                            {applied == "num_marks" ? "Remove" : "Apply"}
                        </Button>
                    </AccordionActions>
                </Accordion>

                {/* <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                    >
                        <Typography>
                            Exam board
                        </Typography>
                        <Box flexGrow={1} />
                        {applied == "board" && <DoneIcon />}
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            value={board}
                            id="board"
                            // label="Exam Board"
                            onChange={(e) => updateBoard(e.target.value)}
                        />
                    </AccordionDetails>
                    <AccordionActions>
                        <Button onClick={() => applyClickHandler(applied == "board" ? false : "board")}>
                            {applied == "board" ? "Remove" : "Apply"}
                        </Button>
                    </AccordionActions>
                </Accordion> */}

                <Accordion expanded={expanded === 'panel3'} onChange={handleAccordionChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                    >
                        <Typography>
                            Year
                        </Typography>
                        <Box flexGrow={1} />
                        {applied == "year" && <DoneIcon />}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Slider
                            value={year}
                            onChange={(e, newValue: number[]) => updateYear(newValue)}
                            valueLabelDisplay="on"
                            sx={{ width: "150px", marginTop: "10px" }}
                            min={MIN_YEAR}
                            max={MAX_YEAR}
                        />
                    </AccordionDetails>
                    <AccordionActions>
                        <Button onClick={() => applyClickHandler(applied == "year" ? false : "year")}>
                            {applied == "year" ? "Remove" : "Apply"}
                        </Button>
                    </AccordionActions>
                </Accordion>

                <Accordion expanded={expanded === 'panel4'} onChange={handleAccordionChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                    >
                        <Typography>
                            Difficulty
                        </Typography>
                        <Box flexGrow={1} />
                        {applied == "difficulty" && <DoneIcon />}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Slider
                            value={difficulty}
                            onChange={(e, newValue: number[]) => updateDifficulty(newValue)}
                            valueLabelDisplay="on"
                            sx={{ width: "150px", marginTop: "10px" }}
                            min={0}
                            max={100}
                        />
                    </AccordionDetails>
                    <AccordionActions>
                        <Button onClick={() => applyClickHandler(applied == "difficulty" ? false : "difficulty")}>
                            {applied == "difficulty" ? "Remove" : "Apply"}
                        </Button>
                    </AccordionActions>
                </Accordion>

            </Drawer>
        </>
    )
}